import { IMG_BASE, baseConfig } from '@com/core/common/baseConfig';
import { TMarketplaceConfig } from '../common/types/config';
import { TRegionAPI, TRegionSEO, TLocaleAPI, TLanguage } from '../common/types/locale';
import { TI18nOptions } from '../common/types/webconfig';

const marketplaceConfig: TMarketplaceConfig = {
    ...baseConfig,
    regions: {
        ...baseConfig.regions,
        ae: {
            ...baseConfig.regions.ae,
            codLimit: 5000,
            enabled: true,
            freeDeliveryCap: 100,
            paymentMethods: ['mastercard', 'visa', 'cod', 'amex'],
            supportEmail: 'care@noon.com',
            supportPhone: 'xxxx',
        },
        sa: {
            ...baseConfig.regions.sa,
            codLimit: 5000,
            enabled: true,
            freeDeliveryCap: 100,
            paymentMethods: ['mastercard', 'visa', 'cod', 'amex'],
            supportEmail: 'care@noon.com',
            supportPhone: 'xxxx',
        },
        eg: {
            ...baseConfig.regions.eg,
            codLimit: 5000,
            enabled: false,
            freeDeliveryCap: 100,
            paymentMethods: ['mastercard', 'visa', 'cod', 'amex'],
            supportEmail: 'care@noon.com',
            supportPhone: 'xxxxx',
        },
    },
    urls: {
        ...baseConfig.urls,
        appStore: 'xxx',
        googlePlay: 'xxx',
        facebook: '',
        twitter: '',
        instagram: '',
        linkedin: '',
        supportInfo: {
            careers: 'https://www.linkedin.com/company/nooncom/jobs/',
            partners: `https://login.noon.partners/en/register`,
        },
    },
    assets: {
        ...baseConfig.assets,
        icons: {
            ...baseConfig.assets.icons,
            shipmentMethod: {
                dd: '',
                sc: '',
                sdd: '',
                fallback: '',
            },
            favicon: `${IMG_BASE}/sivvi/icons/favicon.ico`,
            shipment: '',
            address: '',
            cart: '',
            cartBlue: '',
            cartBlack: '',
            preferences: '',
            checkboxChecked: '',
            checkboxUnchecked: '',
            claims: '',
            collectionPointsToggle: '',
            credits: '',
            edit: '',
            globe: '',
            hamburger: '',
            home: '',
            magnifyingGlass: '',
            orders: '',
            payments: '',
            profile: '',
            returns: '',
            shop: '',
            signOut: '',
            wishListBlack: '',
            wishList: '',
            trash: '',
            user: '',
        },
        images: {
            ...baseConfig.assets.images,
            addressesEmptySlate: '',
            addressCollectionIndicator: '',
            addressLatLngIndicator: '',
            cartEmpty: '',
            claimsEmptySlate: '',
            claimsSuccessSlate: '',
            claimsTypeChecked: '',
            claimsTypeUnchecked: '',
            claimsTypeDamage: '',
            claimsTypeProtection: '',
            defaultMap: '',
            defaultProductPlaceholder: '',
            error404: '',
            fulfilmentExpressAr: '',
            fulfilmentExpressEn: '',
            fulfilmentPreOrderAr: '',
            fulfilmentPreOrderEn: '',
            logoBG: '',
            mapCollectionPointPickup: '',
            mapCollectionPointLocker: '',
            mapCollectionPointToggle: '',
            mapLandmarkPin: '',
            mapLocateMeEn: '',
            mapLocateMeAr: '',
            returnsEmptyState: '',
            returnablesEmptyState: '',
            paymentEmptySlate: '',
            returnSuccess: '',
            transferRequestSuccess: '',
            bankTransferEmpty: '',
            chevronRight: '',
            chevronRightWhite: '',
            secure: '',
        },
    },
    headerSupportBar: false,
    gtm: {
        ...baseConfig.gtm,
        gtmID: 'xxx',
        gaID: 'xxx',
        optimizeID: 'xxx',
    },
    enabledFeatures: {
        loyalty: false,
    },
};

export default marketplaceConfig;

// Computed Locale Configurations
export const SEO_REGIONS = Object.keys(baseConfig.regions).map(
    (region: string) => baseConfig.regions[region as TRegionAPI].seo,
);
const seoLocalesArr = SEO_REGIONS.map(
    (seoRegion: TRegionSEO) =>
        baseConfig.languages.map((language: TLanguage) => `${seoRegion}-${language}` as TLocaleAPI) as TLocaleAPI[],
);
export const SEO_LOCALES = [].concat(...(seoLocalesArr as [])) as TLocaleAPI[];
export const API_REGIONS = Object.keys(baseConfig.regions);

// Common i18n config (server, client)
export const i18nOptions: TI18nOptions = {
    lowerCaseLng: true,
    defaultLanguage: SEO_LOCALES[0],
    otherLanguages: [...SEO_LOCALES, ...baseConfig.extrai18nLocales],
    ignoreRoutes: ['/_next', '/static', '/api', '/hc'],
    whitelist: SEO_LOCALES,
};
